module.exports = {"id":"dp5_1l3q3","text":"Using assistance tools","instructions":"Digital assistants and AI tools can support troubleshooting tasks.","multiselect":false,"category":"5.1","questionType":"PickOne","random":false,"options":[{"id":"dp5_1l3q3-a1","text":"True","score":3.7},{"id":"dp5_1l3q3-a2","text":"Not sure","score":1.3},{"id":"dp5_1l3q3-a3","text":"False","score":1.3}],"groupTitle":"Digital Profiler Knowledge Matrix"}


//////////////////
// WEBPACK FOOTER
// ./src/constants/dp/questions/cat5.1/l3q3.json
// module id = 1288
// module chunks = 41